<template>
  <v-container>
    <v-card>
      <v-card-title>
        <v-row no gutter>
          <v-col cols="12" sm="4"
            >Date : {{ getFormattedDate(this.curTrainDate) }} Train No :
            {{ this.$route.query.train_no }}
          </v-col>
          <v-col cols="12" sm="2">
            <v-btn color="primary" @click="recalcCTR()">
              <v-icon left dark>mdi-refresh</v-icon>Prapare CTR
            </v-btn>
          </v-col>
          <v-col cols="12" sm="2">
            <v-btn color="primary" @click="recalcGoodsCTR()">
              <v-icon left dark>mdi-refresh</v-icon>Prapare G/CTR
            </v-btn>
          </v-col>
          <v-col cols="12" sm="2">
            <v-btn color="primary" @click="createCSV()">
              <v-icon left dark>mdi-download</v-icon>CTR(csv)
            </v-btn>
          </v-col>
          <v-col cols="12" sm="2">
            <v-btn color="primary" @click="createPDF()">
              <v-icon left dark>mdi-download</v-icon>CTR(PDF)
            </v-btn>
          </v-col>
          <v-col cols="12" sm="1">
            <v-btn color="secondary" @click="viewSpeedChart()">
              <v-icon left dark>mdi-chart-line</v-icon>Chart
            </v-btn>
          </v-col>
          <v-col cols="12" sm="1">
            <v-btn color="secondary" @click="viewSpeedOnMap()">
              <v-icon left dark>mdi-traffic-light</v-icon>Map
            </v-btn>
          </v-col>
          <v-col cols="12" sm="1">
            <v-btn color="secondary" @click="viewPowerChart()">
              <v-icon icon="md:power"></v-icon>P-Car
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :fixed-header="true"
        :items="positions"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 40, 50, 100],
        }"
        :items-per-page="40"
        item-key="id"
        @click:row="onRowClick($event)"
        class="elevation-1"
        :loading="isLoading"
        loading-text="Loading... Please wait"
        :mobile-breakpoint="100"
      >
        <!-- <template v-slot:item.act_arr="{ item }">
      {{getFormattedTime(item.act_arr)}}
   </template>
   <template v-slot:item.act_dep="{ item }">
      {{getFormattedTime(item.act_dep)}}
   </template> -->
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import jsonexport from "jsonexport/dist";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as _ from "lodash";
import { saveAs } from "file-saver";
import { mapState, mapGetter, mapActions } from "vuex";
export default {
  name: "positions",
  data() {
    return {
      csvurl: null,
      errors: [],
      headers: [
        {
          text: "Sl No.",
          align: "left",
          sortable: true,
          value: "srl_no",
        },
        {
          text: "Staion",
          align: "left",
          sortable: false,
          value: "stn_code",
        },
        {
          text: "Sch Arr",
          sortable: false,
          value: "sch_arr",
        },
        {
          text: "Sch Dep",
          sortable: false,
          value: "sch_dep",
        },
        {
          text: "Act Arr",
          sortable: false,
          value: "act_arr",
        },
        {
          text: "Act dep",
          sortable: false,
          value: "act_dep",
        },
        {
          text: "Late in",
          value: "late_in",
        },
        {
          text: "late_out",
          value: "late_out",
        },
        {
          text: "Geofence enter speed",
          value: "geofence_enter_speed",
        },
        {
          text: "PF enter speed",
          value: "pf_enter_speed",
        },
        {
          text: "PF enter dist",
          value: "pf_distance",
        },
        {
          text: "Stop Time",
          value: "stop_time",
        },
        {
          text: "Sec. loss/gain on run",
          value: "loss_gain_on_run_formatted",
        },
        {
          text: "Sec. Dist",
          value: "sectional_dist",
          sortable: true,
        },
        {
          text: "Avg. Speed",
          value: "avg_speed",
          sortable: true,
        },
        {
          text: "Max. Speed",
          value: "sec_max_speed",
          sortable: true,
        },
        {
          text: "Distance",
          value: "distance",
          sortable: true,
        },
        {
          text: "Remarks",
          value: "remarks",
          sortable: true,
          width: '300px' 
        },
        {
          text: "Sectional SR",
          value: "sectional_sr",
          sortable: true,
          width: '300px' 
        },
      ],
      position: {},
      positions: [],
      isLoading: false,
    };
  },
  created() {
    // var p = {
    //   train_date: moment(this.curTrainDate).format("YYYY-MM-DD"),
    //   train_no: this.$route.query.train_no,
    //   device_id: this.$route.query.device_id,
    //   org: this.curOrg,
    //   dep: moment(this.curDep).format(),
    //   dest: this.curDest,
    //   arr: moment(this.curArr).add(30,"m").format(),
    // }
    // console.log(p)
    // this.getCtr(p)
    this.updateCurPositions([]);
    this.recalcCTR();

    // axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
    // axios.get(`${process.env.VUE_APP_API_URL}/timetable/tc/events`,{params: p})
    // .then(response => {
    // //  console.log(response.data);
    //   this.positions = response.data
    // //  this.csvurl = this.createCSV()
    // })
    // .catch(e => {
    //   this.errors.push(e)
    //   if(e.response.status === 401) {
    //     this.$router.push({
    //       name: 'Signin'
    //     })
    //   }
    // })
  },
  beforeDestroy() {
    // this.updateCurTrainNo(null)
    // this.updateCurDeviceId(null)
    // this.updateCurDeviceName(null)
    // this.updateCurOrg(null)
    // this.updateCurDep(null)
    // this.updateActDep(null)
    // this.updateCurDest(null)
    // this.updateCurArr(null)
    // this.updateActArr(null)
  },
  computed: {
    ...mapState([
      "curDeviceId",
      "curDeviceName",
      "curTrainNo",
      "curTrainDate",
      "curOrg",
      "curArr",
      "curActArr",
      "curDest",
      "curDep",
      "curActDep",
      "curPosStartId",
      "curPosDestId",
      "curStartTime",
      "curEndTime",
      "curPositions",
    ]),
  },
  methods: {
    ...mapActions([
      "updateCurDeviceId",
      "updateCurDeviceName",
      "updateCurTrainNo",
      "updateCurTrainDate",
      "updateCurOrg",
      "updateCurArr",
      "updateActArr",
      "updateCurDest",
      "updateCurDep",
      "updateActDep",
      "updateCurPosStartId",
      "updateCurPosDestId",
      ,
      "updateCurStartTime",
      "updateCurEndTime",
      "updateCurPositions",
    ]),
    onRowClick($event) {
      //  console.log($event);
    },
    clear() {},
    getCtr(para) {
      this.isLoading = true;
      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "jwtToken"
      );
      //  axios.get(`${process.env.VUE_APP_API_URL}/timetable/tc/geofences`,{params: p})
      axios
        .get(`${process.env.VUE_APP_API_URL}/timetable/tc/punct`, {
          params: para,
        })
        .then((response) => {
          // console.log(response.data);
          this.positions = response.data;
          this.isLoading = false;
        })
        .catch((e) => {
          this.errors.push(e);
          if (e.response.status === 401) {
            this.$router.push({
              name: "Signin",
            });
          }
        });
    },
    getPositions() {
      var p = {
        device_id: this.$route.query.device_id,
        dep: moment(this.curDep).format(),
        arr: moment(this.curArr)
          .add(30, "m")
          .format(),
      };
      this.isLoading = true;
      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "jwtToken"
      );
      //  axios.get(`${process.env.VUE_APP_API_URL}/timetable/tc/geofences`,{params: p})
      axios
        .get(`${process.env.VUE_APP_API_URL}/timetable/tc/positions`, {
          params: p,
        })
        .then((response) => {
          // console.log(response.data);
          this.positions = response.data;
          this.isLoading = false;
        })
        .catch((e) => {
          this.errors.push(e);
          if (e.response.status === 401) {
            this.$router.push({
              name: "Signin",
            });
          }
        });
    },
    getGoodsCtr(para) {
      this.isLoading = true;
      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "jwtToken"
      );
      //  axios.get(`${process.env.VUE_APP_API_URL}/timetable/tc/geofences`,{params: p})
      axios
        .get(`${process.env.VUE_APP_API_URL}/timetable/tc/adhocctr`, {
          params: para,
        })
        .then((response) => {
          // console.log(response.data);
          this.positions = response.data;
          this.updateCurPositions(response.data);
          // this.curPositions = response.data
          this.isLoading = false;
        })
        .catch((e) => {
          this.errors.push(e);
          if (e.response.status === 401) {
            this.$router.push({
              name: "Signin",
            });
          }
        });
    },

    recalcCTR() {
      var p = {
        train_date: moment(this.curTrainDate).format("YYYY-MM-DD"),
        train_no: this.$route.query.train_no,
        device_id: this.$route.query.device_id,
        org: this.curOrg,
        dep: moment(this.curDep).format(),
        dest: this.curDest,
        arr: moment(this.curArr)
          .add(30, "m")
          .format(),
        recalc: true,
      };
      this.getCtr(p);
      // this.getTimeTableCtr(p)
    },
    recalcGoodsCTR() {
      // console.log(this.curDep);
      var p = {
        train_date: moment(this.curTrainDate).format("YYYY-MM-DD"),
        train_no: this.$route.query.train_no,
        device_id: this.$route.query.device_id,
        org: this.curOrg,
        dep: moment(this.curDep).format(),
        dest: this.curDest,
        arr: moment(this.curArr)
          .add(30, "m")
          .format(),
      };
      // console.log(p);
      this.getGoodsCtr(p);
    },

    getTimeTableCtr(para) {
      this.isLoading = true;
      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "jwtToken"
      );
      //  axios.get(`${process.env.VUE_APP_API_URL}/timetable/tc/geofences`,{params: p})
      axios
        .get(`${process.env.VUE_APP_API_URL}/timetable/tc/ctr_for_website`, {
          params: para,
        })
        .then((response) => {
          // console.log(response.data);
          this.positions = response.data;
          this.isLoading = false;
        })
        .catch((e) => {
          this.errors.push(e);
          if (e.response.status === 401) {
            this.$router.push({
              name: "Signin",
            });
          }
        });
    },
    getFormattedTime(t) {
      if (t !== "--") {
        var lt = moment(t).format("YYYY-MM-DD HH:mm:ss");
        var testDateUtc = moment(lt);
        //  var localDate = moment(testDateUtc).local();
        return testDateUtc.format("HH:mm:ss");
      }
    },
    getFormattedDate(t) {
      return moment(t).format("DD/MM/YYYY");
    },
    createPDF() {
      if (this.positions.length == 0) {
        return;
      }
      const doc = new jsPDF({ orientation: "landscape", format: "a4" });
      var totalPagesExp = "{total_pages_count_string}";
      let rows = [];
      var that = this;
      var cnt = 1;
      var tot_tr = 0;
      var tot_er = 0;
      var tot_loss_gain = 0;
      this.positions[0]["late_in"] = "--";
      this.positions[0]["sch_arr"] = "--";
      this.positions[0]["act_arr"] = "--";
      this.positions[0]["stop_time"] = "--";
      this.positions[0]["stn_enter_speed"] = "--";
      this.positions[0]["pf_enter_speed"] = "--";
      this.positions[0]["pf_distance"] = "--";
      this.positions[this.positions.length - 1]["late_out"] = "--";
      this.positions[this.positions.length - 1]["sch_dep"] = "--";
      this.positions[this.positions.length - 1]["act_dep"] = "--";
      this.positions[this.positions.length - 1]["stop_time"] = "--";
      this.positions.forEach((e) => {
        tot_er = tot_er + e["er"];
        tot_tr = tot_tr + e["tr"];
        tot_loss_gain = tot_loss_gain + e["loss_gain_on_run"];
        // console.log(tot_er, tot_tr, tot_loss_gain, e["loss_gain_on_run"]);
        var temp = [
          e["distance"],
          e["stn_code"],
          e["sch_arr"],
          e["act_arr"],
          e["sch_dep"],
          e["act_dep"],
          e["late_in"],
          e["late_out"],
          e["stop_time"],
          e["loss_gain_on_run_formatted"],
          (e["tr"] == 0 ? "" : e["tr"]),
          (e["er"] == 0 ? "" : e["er"]),
          e["sec_max_speed"],
          e["remarks"],
          e["sectional_sr"],
        ];
        rows.push(temp);
      });
      var tot_er_tr = tot_er + tot_tr;
      rows = _.orderBy(rows, ["distance"], ["asc"]);
      // console.log("rows", rows);
      // Or use javascript directly:
      var pageHeight =
        doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
      var pageWidth =
        doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
      doc.autoTable({
        theme: "plain",
        styles: {
          // Defaul style
          lineWidth: 0.01,
          lineColor: 0,
          fillStyle: "DF",
          halign: "center",
          valign: "top",
          cellWidth: "auto",
          overflow: "linebreak",
        },
        head: [
          [
            { content: "KM", rowSpan: 2 },
            { content: "Station", rowSpan: 2 },
            { content: "Arival Time", colSpan: 2 },
            { content: "Departure Time", colSpan: 2 },
            { content: "Late/Before In/Out", colSpan: 2 },
            { content: "Halt\nTime", rowSpan: 2 },
            { content: "Sectional", colSpan: 4 },
            { content: "Reason for detention", rowSpan: 2 },
            { content: "Section SR", rowSpan: 2 }
          ],
          [
            { content: "Booked" },
            { content: "Actual" },
            { content: "Booked" },
            { content: "Actual" },
            { content: "In" },
            { content: "Out" },
            { content: "Loss/Gain" },
            { content: "TM" },
            { content: "EM" },
            { content: "Max Speed" },
          ],
        ],
        body: _.sortBy(rows, ["distance"], ["asc"]),
        foot: [
          [
          { content: "Total Loss/Gain on Run : " + tot_loss_gain , colSpan: 6 },
          { content: "Total TM + EM : " + tot_er_tr*60 + " Late Arr :" + this.positions[this.positions.length - 1]["late_in"], colSpan: 6 },
          ]
        ],
        didDrawPage: function(data) {
          // Header
          doc.setFontSize(14);
          doc.setTextColor(40);
          doc.text("EASTERN RAILWAY", pageWidth / 2, 10, "center");
          doc.setFontSize(12);
          doc.text(
            "COMBINED GURAD'S AND DRIVER'S REPORT",
            pageWidth / 2,
            16,
            "center"
          );
          doc.setFontSize(10);
          doc.text(
            "Note: ONE REPORT IS TO BE MADE FOR EACH COMPLETE DRIVER'S RUN",
            pageWidth / 2,
            20,
            "center"
          );
          doc.text(
            "Engine/Rake No :" +
              that.$route.query.device_name +
              "Class of Engine: EMU " +
              "Train No: " +
              that.$route.query.train_no +
              " Service: Suburban " +
              " Date: " +
              that.getFormattedDate(
                moment(that.curTrainDate).format("YYYY-MM-DD")
              ),
            pageWidth / 2,
            24,
            "center"
          );
          
          // Footer
          var str = 'Page ' + doc.internal.getNumberOfPages()
          // // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === 'function') {
            str = str + ' of ' + totalPagesExp
          }
          doc.setFontSize(10)
          //
          // // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          var pageSize = doc.internal.pageSize
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
          doc.text(str, data.settings.margin.left, pageHeight - 10)
        },
        margin: { top: 30 },
      });
      doc.setProperties({
        title: "CTR",
      });
      doc.output("dataurlnewwindow");
    },

    createCSV() {
      let csvContent = "data:text/csv;charset=utf-8,";
      var filename =
        this.curTrainDate + "-" + this.$route.query.train_no + ".csv";
      var ctr = [];
      for (var i = 0; i < this.positions.length; i++) {
        ctr.push({
          srl_no: this.positions[i]["srl_no"],
          stn_code: this.positions[i]["stn_code"],
          sch_arr: this.positions[i]["sch_arr"],
          sch_dep: this.positions[i]["sch_dep"],
          act_arr: this.positions[i]["act_arr"],
          act_dep: this.positions[i]["act_dep"],
          late_in: this.positions[i]["late_in"],
          late_out: this.positions[i]["late_out"],
          stop_time: this.positions[i]["stop_time"],
          stn_enter_speed: this.positions[i]["geofence_enter_speed"],
          pf_enter_speed: this.positions[i]["pf_enter_speed"],
          pf_distance: this.positions[i]["pf_distance"],
          loss_gain_on_run: this.positions[i]["loss_gain_on_run_formatted"],
          sec_distance: this.positions[i]["sectional_dist"],
          sec_avg_speed: this.positions[i]["avg_speed"],
          sec_max_speed: this.positions[i]["sec_max_speed"],
        });
      }
      ctr[0]["late_in"] = "--";
      ctr[0]["sch_arr"] = "--";
      ctr[0]["act_arr"] = "--";
      ctr[0]["stop_time"] = "--";
      ctr[0]["stn_enter_speed"] = "--";
      ctr[0]["pf_enter_speed"] = "--";
      ctr[0]["pf_distance"] = "--";
      ctr[this.positions.length - 1]["late_out"] = "--";
      ctr[this.positions.length - 1]["sch_dep"] = "--";
      ctr[this.positions.length - 1]["act_dep"] = "--";
      ctr[this.positions.length - 1]["stop_time"] = "--";

      jsonexport(ctr, function(err, csv) {
        if (err) return console.log(err);
        //console.log(csv);
        var blob = new Blob([csv], {
          type: "data:text/csv;charset=utf-8,",
        });
        saveAs(blob, filename);
      });
    },
    viewSpeedChart() {
      // this.$router.push({ name: 'SpeedChart'})

      this.updateCurTrainNo(this.$route.query.train_no);
      this.updateCurDeviceId(this.$route.query.device_id);
      this.updateCurPosStartId(this.positions[0]["pos_start_id"]);
      this.updateCurPosDestId(
        this.positions[this.positions.length - 1]["pos_dest_id"]
      );
      this.$router.push({
        name: "SpeedChartHigh",
      });
      // let routeData = this.$router.resolve({name: 'SpeedChartHigh'});
      // window.open(routeData.href, '_blank');
    },
    viewSpeedOnMap() {
      this.updateCurTrainNo(this.$route.query.train_no);
      this.updateCurDeviceId(this.$route.query.device_id);
      this.updateCurPosStartId(this.positions[0]["pos_start_id"]);
      this.updateCurPosDestId(
        this.positions[this.positions.length - 1]["pos_dest_id"]
      );
      this.$router.push({
        name: "SpeedOnMap",
      });
    },
    viewPowerChart() {
      this.updateCurTrainNo(this.$route.query.train_no);
      this.updateCurDeviceId(this.$route.query.device_id);
      this.updateCurPosStartId(this.positions[0]["pos_start_id"]);
      this.updateCurPosDestId(
        this.positions[this.positions.length - 1]["pos_dest_id"]
      );
      this.$router.push({
        name: "powerCarChartHigh",
      });
    },
    getColor(calories) {
      if (calories > 400) return "red";
      else if (calories > 200) return "orange";
      else return "green";
    },
  },
};
</script>
